import { Vue, Component, Inject, Prop, Watch, Setup } from "@wagich/vue-facing-decorator-metadata";
import { type FormField, FieldWidth, type Form } from "./models";
import { enforce, test, type Suite, type SuiteResult } from "vest";

@Component({
	emits: ["update:modelValue"],
})
export class CustomFormField<TField extends FormField = FormField, TFieldValue = any> extends Vue {
	isDirty: boolean = false;

	@Prop() form: Form;
	@Prop() field: TField;
	@Prop() values: any;
	@Prop() modelValue: TFieldValue;
	@Prop() validations: SuiteResult<string, string>;

	get columnWidthClass(): string {
		switch (this.field.width) {
			case FieldWidth.ThreeQuarters:
				return "is-three-quarters";
			case FieldWidth.Half:
				return "is-half";
			case FieldWidth.OneQuarter:
				return "is-one-quarter";
			case FieldWidth.Full:
			default:
				return "is-full";
		}
	}

	get fieldType(): string | undefined {
		if (this.validations.hasErrors(this.field.name) && this.isDirty) {
			return "is-danger";
		} else if (this.validations.isValid(this.field.name)) {
			return "is-success";
		}
	}

	get labelColor(): string | undefined {
		if (this.validations.hasErrors(this.field.name)) {
			return "has-text-danger";
		}
	}

	get fieldMessage(): string | null {
		if (this.validations.hasErrors(this.field.name)) {
			return this.validations.getErrors(this.field.name).join(", ");
		} else {
			return this.field.hint;
		}
	}

	setDirty() {
		this.isDirty = true;
	}

	onInput(value: TFieldValue | null) {
		if ((value != null && value !== "") || (this.modelValue != null || this.modelValue !== "")) {
			this.setDirty();
		}
		this.$emit("update:modelValue", value);
	}

	createValidator(data: any): void {
		if (this.field.required) {
			test(this.field.name, "Bitte füllen Sie dieses Feld aus.", () => {
				enforce(data[this.field.name]).isNotEmpty();
			});
		}
	}
}
